import { Table, ActionIcon, Menu } from '@mantine/core';
import { modals } from '@mantine/modals';
import { IconDotsVertical, IconEdit, IconTrash } from '@tabler/icons-react';

import { CustomTable, CustomTableMobile, useResponsive } from '@/shared';
import { WithdrawalMethodUpdateForm } from './withdrawal-method-update-form';
import { WithdrawalMethodActiveUpdate } from './withdrawal-method-active-update';
import { useDeleteWithdrawalMethod } from '../hooks/use-delete-withdrawal-method';

import type { TWithdrawalMethod } from '../store/types';

type Props = {
  items: TWithdrawalMethod[];
  isLoading?: boolean;
};

export const WithdrawalMethodsTable = (props: Props) => {
  const { items } = props;
  const { isDesktop } = useResponsive();
  const {
    openDeleteModal,
  } = useDeleteWithdrawalMethod();

  const openEditModal = (item: TWithdrawalMethod) => modals.open({
    title: `Редактирование метода "${item.name}"`,
    // centered: true,
    children: (
      <WithdrawalMethodUpdateForm
        method={item}
        onClose={modals.closeAll}
      />
    ),
  });

  const getActions = (item: TWithdrawalMethod) => (
    <Menu position="bottom-end" shadow="md" width={200}>
      <Menu.Target>
        <ActionIcon variant="subtle">
          <IconDotsVertical size={16} />
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconEdit size={14} />}
          onClick={() => openEditModal(item)}
        >
          Редактировать
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item
          color="red"
          leftSection={<IconTrash size={14} />}
          onClick={() => openDeleteModal(item)}
        >
          Удалить
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );

  const titles = [
    'ID метода',
    'Название',
    'Валюта',
    'Мин. сумма',
    'Макс. сумма',
    'Активен',
    'Процент вывода',
    'Фикс',
  ];

  const rows = items.map((item) => (
    <Table.Tr key={item.id}>
      <Table.Td>{item.id}</Table.Td>
      <Table.Td>{item.name}</Table.Td>
      <Table.Td>{item.currency}</Table.Td>
      <Table.Td>{item.minAmount}</Table.Td>
      <Table.Td>{item.maxAmount}</Table.Td>
      <Table.Td>
        <WithdrawalMethodActiveUpdate method={item} />
      </Table.Td>
      <Table.Td>{item.withdrawalPercent}</Table.Td>
      <Table.Td>{item.withdrawalFee}</Table.Td>
      <Table.Td width={50}>{getActions(item)}</Table.Td>
    </Table.Tr>
  ));

  const rowsMobile = items.map((item) => ({
    key: item.id,
    headerActions: getActions(item),
    items: [
      { name: titles[0], value: item.id },
      { name: titles[1], value: item.name },
      { name: titles[2], value: item.currency },
      { name: titles[3], value: item.minAmount },
      { name: titles[4], value: item.maxAmount },
      { name: titles[5], value: <WithdrawalMethodActiveUpdate method={item} /> },
      { name: titles[6], value: item.withdrawalPercent },
      { name: titles[7], value: item.withdrawalFee },
    ],
  }));

  return isDesktop
    ? (
      <CustomTable
        titles={titles}
        rows={rows}
        isPaginated={false}
        {...props}
      />
    )
    : (
      <CustomTableMobile
        rows={rowsMobile}
        headerPointsCount={3}
        isPaginated={false}
        {...props}
      />
    );
};
